import { all, takeEvery } from "redux-saga/effects";
import { AppEvent, AppEventFired } from "@modules/app-events";

export function* onEventFired({ payload }) {
  if (!(payload instanceof AppEvent)) {
    return;
  }

  try {
    yield console.error(payload.data.action.type, payload.data.action.payload.data);
    yield console.table({
      ...payload.data.action.payload.data,
      ...payload.data.browser,
    });
  } catch (e) {
    console.error("Saga error: ", e);
  }
}

export function* graylogSaga() {
  yield all([takeEvery(AppEventFired, onEventFired)]);
}

export default graylogSaga;
